<template>
  <div class="column_center_start order_history" @click="spreadOrderItem">
    <div
      class="row_center_between w-full px-[4%] pb-[15px] border-b border-dotted border-[#999999]"
    >
      <div
        class="row_center_start"
        style="flex-grow: 1; flex-direction: row; overflow: hidden"
      >
        <text
          class="order_type shrink-0"
          :class="{
            order_type_refund:
              item.isCancelledByUser || item.isCancelledByStore,
          }"
          >{{ item.displayConsumptionPattern }}</text
        >
        <text
          class="order_number"
          style="flex-grow: 1; text-overflow: ellipsis; overflow: hidden"
          >{{ item.displayOrderNumber }}</text
        >
      </div>
      <!-- <text class="order_amount">${{ item.orderTotalPrice }}</text> -->
      <text class="order_amount">${{ item.displayTotalPrice }}</text>
    </div>
    <div
      class="row_center_start w-full px-[4%] mt-1.5 flex-wrap overflow-hidden"
    >
      <!-- <div class="row_center_start grow"> -->
      <!-- 訂單編號 -->
      <div
        class="row_center_center shrink-0 px-2.5 mt-2 py-1 border mr-1 border-[#FD5001] text-primary-color font-medium text-sm rounded-[50px]"
      >
        <text v-if="item.isDineIn"
          >門市內用編號：{{ item.orderNumberTrailing }}</text
        >
        <text v-if="item.isTakeOut"
          >現場外帶編號：{{ item.orderNumberTrailing }}</text
        >
        <text v-if="item.isPickUp"
          >預約自取編號：{{ item.orderNumberTrailing }}</text
        >
        <text v-if="item.isDelivery"
          >店家外送編號：{{ item.orderNumberTrailing }}</text
        >
        <text v-if="item.isRetailPickUp"
          >零售自取編號：{{ item.orderNumberTrailing }}</text
        >
        <text v-if="item.isRetailDelivery"
          >零售宅配編號：{{ item.orderNumberTrailing }}</text
        >
        <text v-if="item.isSafekeeping"
          >保管編號：{{ item.orderNumberTrailing }}</text
        >
      </div>
      <!-- 線上訂單 訂單狀態 -->
      <text class="payment_status payment_status_refund">{{
        item.displayOrderStatus
      }}</text>
      <!-- <text class="payment_status" :class="paymentClass(paymentType)"
                    v-for="(paymentType, index) in item.displayPaymentType" :key="index">
                    {{ paymentType }}
                </text> -->
      <text
        class="payment_status"
        :class="
          paymentClass(
            isRetailCashOnline ? '店家自訂' : item.displayPaymentType
          )
        "
      >
        {{ isRetailCashOnline ? "店家自訂" : item.displayPaymentType }}
      </text>
      <text
        class="payment_status payment_status_red_border"
        v-if="item.bonusUsed"
        >紅利積分</text
      >
      <text
        class="payment_status payment_status_red_border"
        v-if="item.couponUsed"
        >優惠卷</text
      >
      <!-- </div> -->
      <!-- 根據需求隱藏取消訂單按鈕 -->
      <!-- <div class="w-full row_center_start mt-2">
                <button class="text-primary-color font-medium px-2.5 py-1 border border-[#FD5001] text-sm rounded-[50px]" v-if="cancelable && item.isUnprocessed"
                @click="$emit('cancelOrder', item)">取消訂單</button>
             </div> -->
    </div>
    <!-- 付款失敗：提醒消費者此單不會成立 -->
    <div
      class="row_center_start w-full px-[4%] mt-2"
      v-if="item.isPaymentFailedOrder"
    >
      <text class="text-sm text-[#D60A0A]">※ 此訂單已失效，請重新下單</text>
    </div>
    <div class="row_start_start w-full px-[4%] mt-2.5">
      <div class="column_start_start" style="width: 100%">
        <div class="row_center_start order_time">
          <text>{{ item.checkOutTimeText }}時間</text>
          <text style="margin: 0 5px">:</text>
          <text>{{ item.checkOutTime }}</text>
        </div>
        <div v-if="item.takeOrderTime" class="row_center_start order_time">
          <text>{{ item.takeOrderTimeText }}</text>
          <text style="margin: 0 5px">:</text>
          <text>{{ item.takeOrderTime }}</text>
        </div>
        <!-- 外送資訊（外送與零售宅配顯示） -->
        <div v-if="item.isDeliveryType" class="column_start_start w-full">
          <div
            class="row_center_start order_time"
            v-if="resolvedDeliveryAddress(item)"
          >
            <text>地址：{{ resolvedDeliveryAddress(item) }}</text>
          </div>
          <div
            class="row_center_start order_time"
            v-if="item.orderContent.deliveryRecipient"
          >
            <text>聯絡人：{{ item.orderContent.deliveryRecipient }}</text>
          </div>
          <div
            class="row_center_start order_time"
            v-if="item.orderContent.deliveryContactPhone"
          >
            <text>電話：{{ item.orderContent.deliveryContactPhone }}</text>
          </div>
          <div
            class="row_center_start order_time"
            v-if="item.orderContent.vatNumber"
          >
            <text>統一編號：{{ item.orderContent.vatNumber }}</text>
          </div>
        </div>
        <div class="column_start_start order_item_list">
          <div
            class="row_center_start"
            style="width: 100%"
            v-for="(orderItem, index) in item.orderGoods"
            :key="index"
          >
            <div
              class="column_start_start order_item"
              v-if="
                (index < 2 && !spreaded) ||
                (index < 2 && spreaded) ||
                (item.orderGoods.length > 2 && spreaded)
              "
            >
              <div
                class="row_center_start w-full"
                :class="{ order_item_header_expanded: spreaded }"
              >
                <text
                  class="product_name"
                  :class="{ product_name_expanded: spreaded }"
                  >{{ orderItem.productName }}</text
                >
                <text class="row_center_center order_count shrink-0">{{
                  orderItem.count
                }}</text>
                <text class="ml-2 text-xl shrink-0"
                  >${{ orderItem.displayPrice }}</text
                >
              </div>
              <div
                class="row_center_start w-full text-base text-[#938132]"
                :class="orderItem.selectedSpecOptions.length ? 'mt-1.5' : ''"
              >
                {{ displayText(orderItem.selectedSpecOptions) }}
              </div>
              <div
                class="row_center_start w-full flex-wrap text-sm text-[#938132]"
                v-if="orderItem.note"
                :class="orderItem.note ? 'mt-1.5' : ''"
              >
                <text>備註：{{ orderItem.note }}</text>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row_center_start folded_order"
          v-if="item.orderGoodsLength > 2 && !spreaded"
        >
          <text>+尚有{{ item.orderGoodsLength - 2 }}項</text>
        </div>
        <div
          class="border-t-2 border-[#999999] w-full mt-2 mb-3"
          v-if="
            item.orderContent.hasAdditionalFee || item.orderContent.orderNote
          "
        ></div>
        <!-- <div class="row_center_start w-full fee mb-1.5"
                    v-if="item.orderContent.orderSpecs && item.orderContent.orderSpecs.length">
                    {{ item.orderContent.displayOrderSpecOptionsText }}
                </div> -->
        <div
          class="column_start_start w-full"
          v-if="item.orderContent.hasAdditionalFee"
        >
          <div
            class="row_center_between fee w-full mb-1.5"
            v-if="item.orderContent.serviceFee !== 0"
          >
            <text>服務費：</text>
            <text>${{ item.orderContent.serviceFee }}</text>
          </div>
          <div
            class="row_center_between fee w-full mb-1.5"
            v-if="item.orderContent.discountPrice != 0 && !item.isChildOrder"
          >
            <text>現場折價：</text>
            <text class="discount"
              >-${{ item.orderContent.discountPrice }}</text
            >
          </div>
          <div
            class="row_center_between fee w-full mb-1.5"
            v-if="item.orderContent.onSiteDiscount !== 0"
          >
            <text>現場減價：</text>
            <text class="discount"
              >-${{ item.orderContent.onSiteDiscount }}</text
            >
          </div>
          <div
            class="row_center_between fee w-full mb-1.5"
            v-if="item.orderContent.extraFee !== 0"
          >
            <text>額外費用：</text>
            <text>${{ item.orderContent.extraFee }}</text>
          </div>
          <div
            class="row_center_between fee w-full mb-1.5"
            v-if="item.orderContent.pointDiscount !== 0"
          >
            <text>紅利積分減價：</text>
            <text class="discount"
              >-${{ item.orderContent.pointDiscount }}</text
            >
          </div>
          <!-- 刷卡手續費顯示 -->
          <div
            class="row_center_between fee w-full mb-1.5"
            v-if="item.orderContent.creditCardSurcharge !== 0"
            data-testid="credit-card-surcharge"
          >
            <text>刷卡手續費：</text>
            <text>${{ item.orderContent.creditCardSurcharge }}</text>
          </div>
          <!-- 運費顯示（僅外送訂單且運費不為 0 時顯示） -->
          <div
            class="row_center_between fee w-full"
            v-if="item.orderContent.shippingFee !== 0"
          >
            <text>運費：</text>
            <text>${{ item.orderContent.shippingFee }}</text>
          </div>
        </div>
        <!-- 訂單備註 預設展開 -->
        <div
          class="row_center_start w-full px-3 h-9 shrink-0 bg-[#F0F0F0]"
          :class="item.orderContent.hasAdditionalFee ? 'mt-2' : ''"
          v-if="item.orderContent.orderNote"
          @click="showNote = !showNote"
        >
          <text
            class="button-icon text-2xl mr-2.5 size-6"
            :class="showNote ? 'rotate-180' : 'rotate-0'"
          >
            arrow_drop_up
          </text>
          <text class="text-base">訂單備註</text>
        </div>
        <div
          class="row_center_start w-full px-3 py-1.5 shrink-0 bg-[#F0F0F0]"
          v-if="item.orderContent.orderNote && showNote"
        >
          <text class="text-[#666666] text-left text-base">{{
            item.orderContent.orderNote
          }}</text>
        </div>
        <div
          v-if="isRetailCashOnline && customPaymentText"
          class="order-custom-payment-description"
        >
          <div class="custom-payment-inner">
            <div>店家自訂支付說明：</div>
            <div v-html="customPaymentText"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
    },
    cancelable: {
      type: Boolean,
      default: false,
    },
    isOnlineContext: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      spreaded: false,
      showNote: true,
    };
  },
  computed: {
    cities() {
      return this.$store.state.basic.cities || [];
    },
    cityAreas() {
      return this.$store.state.basic.cityAreas || [];
    },
    customPaymentText() {
      return this.$store.getters["basic/customPaymentText"];
    },
    isRetailCashOnline() {
      return (
        this.isOnlineContext &&
        (this.item.isRetailPickUp || this.item.isRetailDelivery) &&
        this.item.paymentType === "cash"
      );
    },
  },
  methods: {
    spreadOrderItem() {
      this.spreaded = !this.spreaded;
    },
    // 解析外送地址，若地址不含縣市則透過 cityID/cityAreaID 補全
    resolvedDeliveryAddress(item) {
      const address = item.orderContent.deliveryAddress;
      if (!address) return "";

      // 檢查地址是否已包含縣市名稱
      const hasCity = this.cities.some((city) => address.startsWith(city.name));
      if (hasCity) return address;

      // 地址不含縣市，嘗試透過 cityID/cityAreaID 補全
      const orderDelivering = item.orderContent.orderDelivering || {};
      const cityID = orderDelivering.cityID;
      const cityAreaID = orderDelivering.cityAreaID;

      const cityName = cityID
        ? this.cities.find((c) => c.id == cityID)?.name ?? ""
        : "";
      const cityAreaName = cityAreaID
        ? this.cityAreas.find((a) => a.id == cityAreaID)?.name ?? ""
        : "";

      return cityName + cityAreaName + address;
    },
    paymentClass(type) {
      if (type === "LINE Pay") {
        return "payment_status_linePay";
      }
      if (type === "街口支付") {
        return "payment_status_jkoPay";
      }
      return "payment_status_yellow_bg";
    },
    displayText(selectedSpecOptions) {
      if (!selectedSpecOptions || selectedSpecOptions.length === 0) {
        return "";
      }

      return selectedSpecOptions
        .map((product, productIndex) => {
          let productText = "";

          if (product.title) {
            productText += product.title;
            if (product.altAddonPrice) {
              productText += `+${product.altAddonPrice}`;
            }
            //顯示套餐子向數量
            if (product.count && product.count > 1) {
              productText += ` x${product.count}`;
            }
            if (product.specOptions && product.specOptions.length > 0) {
              productText += "：";
            }
          }

          if (product.specOptions && product.specOptions.length > 0) {
            productText += product.specOptions
              .map((spec, specIndex) => {
                let specText = "";
                if (spec.options && spec.options.length) {
                  specText += spec.options
                    .map((option, optionIndex) => {
                      let optionText = "";
                      optionText += option;
                      if (optionIndex < spec.options.length - 1) {
                        optionText += "、";
                      }
                      return optionText;
                    })
                    .join("");
                  if (specIndex < product.specOptions.length - 1) {
                    specText += "、";
                  }
                }
                return specText;
              })
              .join("");
          }

          if (productIndex < selectedSpecOptions.length - 1) {
            productText += " / ";
          }

          return productText;
        })
        .join("");
    },
  },
};
</script>
<style lang="scss" scoped>
.order_item_header_expanded {
  align-items: flex-start;
}

.product_name {
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 95%;
}

.product_name_expanded {
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
  word-break: break-word;
  max-width: none;
}

.fee {
  color: #000000;
  font-family: PingFang TC;
  font-size: 20px;
  font-weight: 500;
}

.discount {
  color: #d60a0a;
  font-family: PingFang TC;
  font-size: 20px;
  font-weight: 500;
}

.order-custom-payment-description {
  width: 100%;
  margin-top: 8px;
  padding: 8px 12px;
  font-size: 13px;
  color: #fd5001;
  line-height: 1.5;
  border: 1px solid #fd5001;
  border-radius: 6px;
  display: flex;
  justify-content: center;
}

.custom-payment-inner {
  text-align: left;
}
</style>
